import Vue from 'vue'

Vue.filter('money', (input) => {
  const output = (parseFloat((input || 0).toString()) || 0.0).toFixed(2)
  return output
})
